import classNames from 'classnames';

const NightButton = ({ value, onClick, selected, notActive, variant = 'white' }) => {
  return (
    <button
      onClick={onClick}
      className={classNames('move-day-button px-2 py-3 gap-1 label-medium leading-none rounded-xl', {
        'move-day-button--selected': selected,
        'move-day-button--not-active': notActive,
        'move-day-button--white': variant === 'white',
        'move-day-button--gray': variant === 'gray',
      })}
    >
      {value}
    </button>
  );
};

export default NightButton;
